import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ActivityProductiveSection,
  CardUpperText,
  HoverSection,
  NoteDeleteSection,
  SingleCardContainer,
  TimeMonitorSection,
} from '../../styledComponents/Activity';
import { CommonText } from '../../styledComponents/common';
import { ActivityTextSection } from '../../styledComponents/members';
import PhotoItem from './PhotoItem';

const SingleCard = props => {
  const { selfieItem, imageId, image, timestamp, user, officeNumber, taskCode } = props;
  const { t } = useTranslation();

  const [hover, setHover] = useState(false);
  const [timeDuration, setTimeDuration] = useState(0);

  const [monitorHovered, setMonitorHovered] = useState(null);
  const [screenshotHovered, setScreenshotHovered] = useState(null);

  return (
    <SingleCardContainer>
      <CardUpperText>
        <ActivityTextSection gap="2px">
          <CommonText fontSize="13px" name title margin="0">
          {t('office_number')}: {officeNumber}
          </CommonText>
        </ActivityTextSection>
      </CardUpperText>
      <div style={{ position: `relative` }}>
        <PhotoItem item={selfieItem} image={image} selfieImageId={imageId} />
      </div>
      <TimeMonitorSection main>
      <CommonText fontSize="13px" name title margin="0">
          {user? user: t('unknown')}
        </CommonText>
        <CommonText fontSize="13px" name title margin="0">
          {timestamp}
        </CommonText>
      </TimeMonitorSection>
    </SingleCardContainer>
  );
};

export default SingleCard;
